'use strict';

var intellidealerAppQuotesModule = angular.module('intellidealerApp.quotes', ['intellidealerApp.core']);
